export interface User {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  headsetId?: string;
  headsetName?: string;
  headsetCountryCode?: string;
  headquarterId?: string;
  headquarterName?: string;
  hospitalId?: string; // New field for hospital ID
  hospitalName?: string; // New field for hospital name
  role?: UserRole;
  isStreaming?: boolean;
}

export enum UserRole {
  Admin = "admin",
  HeadquarterAdmin = "headquarterAdmin",
  HeadsetAdmin = "headsetAdmin",
  User = "user",
  Guest = "guest",
}
